// extracted by mini-css-extract-plugin
export default {"prev-next-btn":"SingleQuestionnaireContainerStyles_prev-next-btn__D58Gn","submit-btn":"SingleQuestionnaireContainerStyles_submit-btn__OClME"};